import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { CWT_APP_CONFIG, CwtAppConfig } from '@mobile/modules/core/core-app.config';
import { NotificationStore } from './notification.store';

@Injectable({ providedIn: 'root' })
export class NotificationCheckGuard implements CanDeactivate<any> {
    constructor(
        @Inject(CWT_APP_CONFIG) private appConfig: CwtAppConfig,
        private store: NotificationStore
    ) { }

    canDeactivate(
        _component: any,
        _currentRoute: ActivatedRouteSnapshot,
        _currentState: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.appConfig.partner.useNotification) return true;
        this.store.check().subscribe();
        return true;
    }
}